import TeamSelect from '../../TeamSelect';
import type { UserTabProps } from '../../types';

const UserTabAccessExecutor = ({ user, dispatchUser }: UserTabProps) => {
    return (
        <TeamSelect
            value={user?.access?.team as number | undefined}
            onChange={(aOpt) => {
                dispatchUser({
                    type: 'SET_ACCESS_FIELD',
                    field: 'team',
                    value: aOpt?.value || 0,
                });
            }}
        />
    );
};

export default UserTabAccessExecutor;
